import { i18n as I18n } from "i18next";
import { useTranslation } from "react-i18next";
import { TranslationNamespace, TranslationSource } from "../i18n";

interface AppTranslations {
  t: (key: TranslationSource, values?: any) => string;
  ns: TranslationNamespace;
  i18n: I18n;
}

export default function useAppTranslations(
  ns: TranslationNamespace = "common"
): AppTranslations {
  const [t, i18n] = useTranslation(ns);

  return {
    t,
    ns,
    i18n
  };
}
